module.exports = __webpack_public_path__ + "static/media/instagram.8717c9ab.svg";